import React, { createContext, useContext, useState } from "react";

const ChatbotContext = createContext();

  const apiSessionId = sessionStorage.getItem("sessionId");
  console.log("sessionId", apiSessionId);

export const ChatbotProvider = ({ children }) => {
  const [isChatbotMinimized, setIsChatbotMinimized] = useState(true); // Initially minimized
  const [isChatbotVisible, setIsChatbotVisible] = useState(true); // Control visibility

  return (
    <ChatbotContext.Provider value={{ 
      isChatbotMinimized, 
      setIsChatbotMinimized, 
      isChatbotVisible, 
      setIsChatbotVisible 
    }}>
      {children}
    </ChatbotContext.Provider>
  );
};

export const useChatbot = () => useContext(ChatbotContext);
